import { ILoggingService } from './loggingService';

export interface IWindowWithGoogleAnalytics extends Window {
    ga: { getAll(): [{ send: (hitType: string, fieldsObject: {}) => void }] };
}

let loggingService: ILoggingService;

export const setGAServiceLoggingService = (aLoggingService: ILoggingService) => {
    loggingService = aLoggingService;
}

export const gAService = (() => {

    const sendEvent = (eventCategory: string, eventAction: string, label: string, asBeacon: boolean = false) => {
        try {
            const windowWithGA: IWindowWithGoogleAnalytics = window as unknown as IWindowWithGoogleAnalytics;
            if (windowWithGA.ga && windowWithGA.ga.getAll) {
                let gaInstances = windowWithGA.ga.getAll();
                const foundGAIs = gaInstances;
                for (let i = 0; i < foundGAIs.length; i++) {
                    let g = foundGAIs[i];
                    let data: any = {
                        eventCategory: eventCategory,
                        eventAction: eventAction,
                        eventLabel: label,
                        nonInteraction: true
                    };
                    if (asBeacon) {
                        data.transport = 'beacon';
                    }
                    g.send("event", data);
                }
            }
        } catch (e) {
            loggingService?.error(`Error GAService.SendEvent ${eventCategory} ${eventAction} ${label}`, e)
        }
    }

    const sendException = (description: string, isFatal: boolean) => {
        try {
            const windowWithGA: IWindowWithGoogleAnalytics = window as unknown as IWindowWithGoogleAnalytics;
            if (windowWithGA.ga && windowWithGA.ga.getAll) {
                let gaInstances = windowWithGA.ga.getAll();
                const foundGAIs = gaInstances;
                for (let i = 0; i < foundGAIs.length; i++) {
                    let g = foundGAIs[i];
                    let data: any = {
                        exDescription: description,  //https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#exDescription
                        exFatal: isFatal,
                    };
                    g.send("exception", data);
                }
            }
        } catch (e) {
            loggingService?.error(`Error GAService.sendException ${description} ${isFatal}`, e)
        }
    }

    const sendTiming = (timingCategory: string, timingVar: string, timingValue: number, asBeacon: boolean = false) => {
        try {
            const windowWithGA: IWindowWithGoogleAnalytics = window as unknown as IWindowWithGoogleAnalytics;
            if (windowWithGA.ga && windowWithGA.ga.getAll) {
                let gaInstances = windowWithGA.ga.getAll();
                const foundGAIs = gaInstances;
                for (let i = 0; i < foundGAIs.length; i++) {
                    let g = foundGAIs[i];
                    let data: any = {
                        timingCategory: timingCategory,
                        timingVar: timingVar,
                        timingValue: timingValue,
                        nonInteraction: true
                    };
                    if (asBeacon) {
                        data.transport = 'beacon';
                    }
                    g.send("timing", data);
                }
            }
        } catch (e) {
            loggingService?.error(`Error GAService.SendTiming ${timingCategory} ${timingVar} ${timingValue}`, e)
        }
    }

    return {
        sendEvent,
        sendException,
        sendTiming
    }

})();